import {
  Button,
  Image,
  Text,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Box,
  Stat,
  StatHelpText,
  StatArrow,
  Divider
} from "@chakra-ui/react";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { theme } from "../../styles/theme";
import { FaShareAlt, FaEye, FaTimes } from 'react-icons/fa';
import swal  from 'sweetalert';
import { LazyLoadImage } from 'react-lazy-load-image-component';

export function ProductPageCard({
  id,
  name,
  brand,
  marketPrice,
  prices,
  batch,
  productPhotoUrl,
  productFlyerUrl,
  quantityPerBox,
  size,
  productType,
  suggestedPriceForSale,
  description
}) {

  const { id: productId } = useParams()
  const { min, max } = (prices || []).reduce((acc, cur) => {
    if (cur.price_per_unity < acc.min) {
      acc.min = cur.price_per_unity;
    }
    if (cur.price_per_unity > acc.max) {
      acc.max = cur.price_per_unity;
    }
    return acc;
  }, { min: Infinity, max: -Infinity }) || {};

  const { isOpen, onOpen, onClose } = useDisclosure()
  const [isExpanded, setIsExpanded] = useState(false);
  const toggleImageExpansion = () => {
    setIsExpanded(!isExpanded);
  };

  const shareProductLink = (e) => {
    e.preventDefault()
    navigator.clipboard.writeText(e.target.dataset.copyText).then((error) => {
      swal({
        title: "👍",
        text: "Link copiado!",
        icon: "success",
      });
    })
  }

  const primaryGreen = theme.colors.primaryGreen;
  const primaryOrange = theme.colors.primaryOrange;

  const productTypeName = productType?.name ? productType.name.replace(/(%20|\s+)/g, "+") : "";
  const productName = name ? name.replace(/(%20|\s+)/g, "+") : "";
  const minUnity = prices.reduce((min, current) => (current.unity < min ? current.unity : min), prices[0]?.unity);
  return (<>
    <Box
      borderRadius="16px"
      border={`1px solid rgba(0, 74, 51, 0.08)`}
      height='auto'
      width={{ base: '100%', md: '100%' }}
      marginBottom={{ base: '20px', md: '0' }}
      display='flex'
      flexDirection='column'
      paddingBottom='0px'
      position='relative'
      boxShadow="0 4px 16px rgba(0, 74, 51, 0.08)"
      bg="white"
      overflow="hidden"
      transition="all 0.3s ease"
      _hover={{
        boxShadow: "0 8px 24px rgba(0, 74, 51, 0.12)",
        borderColor: "rgba(0, 74, 51, 0.16)"
      }}
    >
      <Box position="relative" overflow="hidden" borderRadius="16px 16px 0 0" onClick={toggleImageExpansion} cursor="pointer">
        <LazyLoadImage
          src={productPhotoUrl || require('../../assets/images/placeholder.webp')}
          alt="Boozen"
          effect="blur"
          style={{
            objectFit: "contain",
            width: "100%",
            height: "280px",
            display: "block",
            transition: "transform 0.3s ease",
          }}
          wrapperProps={{
            style: { display: "block", width: "100%", height: "280px" },
          }}
          loading="lazy"
        />
        <Button
          bg={primaryOrange}
          id="copy-paste"
          padding='0'
          margin='0'
          borderRadius='50%'
          fontSize='14px'
          data-copy-text={`Confira essa oferta na Boozen - ${name} - ${brand}: http://boozen.com.br/produtos/${productTypeName}/${productName}`}
          onClick={(e) => shareProductLink(e)}
          _hover={{ bg: primaryGreen, color: primaryOrange, boxShadow: "0 4px 12px rgba(252, 143, 4, 0.3)" }}
          position='absolute'
          right='16px'
          top='16px'
          color="white"
          width='44px'
          height='44px'
          minWidth='none'
          display="inline-flex"
          alignItems="center"
          justifyContent="center"
          boxShadow="0 2px 8px rgba(0, 0, 0, 0.15)"
          transition="all 0.25s ease"
        >
          <FaShareAlt></FaShareAlt>
        </Button>
        {batch && (
          <Box
            position="absolute"
            top="16px"
            left="16px"
            bg={primaryOrange}
            color="white"
            borderRadius="999px"
            px="12px"
            py="4px"
            fontWeight="900"
            fontSize="14px"
            boxShadow="0 2px 8px rgba(252, 143, 4, 0.3)"
          >
            {batch.discount_per_centage}% OFF
          </Box>
        )}
      </Box>
      <Box px="20px" py="16px">
        <Text fontWeight='900' fontSize="16px" color={primaryGreen} noOfLines={2} mb="4px">{name}</Text>
        <Text fontWeight='500' fontSize="14px" color="rgba(0, 74, 51, 0.6)" mb="12px">{brand}</Text>

        {productFlyerUrl && (
          <Button
            onClick={onOpen}
            background="transparent"
            padding="0"
            textDecoration="none"
            fontWeight="500"
            fontSize="13px"
            color={primaryGreen}
            mb="8px"
            _hover={{ color: primaryOrange }}
            display="flex"
            alignItems="center"
            gap="6px"
          >
            <FaEye size="12px" />
            Preço no mercado: <Text as="span" textDecoration='line-through' ml="4px">{marketPrice?.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}</Text>
          </Button>
        )}

        <Box mb="12px">
          <Text color={primaryOrange} fontWeight='900' fontSize={{ base: '20px', md: '22px' }}>
            {(min).toLocaleString('pt-br', {style: 'currency', currency: 'BRL'})}
          </Text>
          <Text fontWeight='500' fontSize="13px" color="rgba(0, 74, 51, 0.7)">
            A partir de
          </Text>
        </Box>

        <Box bg="rgba(0, 74, 51, 0.04)" border="1px solid rgba(0, 74, 51, 0.08)" borderRadius="8px" p="12px" mb="12px">
          <Text fontWeight='600' fontSize="13px" color={primaryGreen} mb="4px">
            Mínimo de compra:
          </Text>
          <Text fontWeight='500' fontSize="14px" color="rgba(0, 74, 51, 0.8)">
            {quantityPerBox * minUnity} {size ? <span>{size}</span> : <span></span>}{quantityPerBox > 1 && size ? <span>s</span> : <span></span>}
          </Text>
        </Box>

        {suggestedPriceForSale && (
          <Box bg="rgba(252, 143, 4, 0.05)" border="1px solid rgba(252, 143, 4, 0.1)" borderRadius="8px" p="12px" mb="12px">
            <Text fontSize="12px" color="rgba(0, 74, 51, 0.7)" mb="2px">Sugestão de revenda:</Text>
            <Text fontWeight='700' fontSize="16px" color={primaryOrange}>R${suggestedPriceForSale.toFixed(2)}</Text>
          </Box>
        )}

        {description && (<>
          <Divider my="12px" borderColor="rgba(0, 74, 51, 0.1)"/>
          <Box>
            <Text fontWeight='600' fontSize="14px" color={primaryGreen} mb="8px">Descrição:</Text>
            <Box fontSize="13px" color="rgba(0, 74, 51, 0.7)" lineHeight="1.5">
              <div dangerouslySetInnerHTML={{ __html: description }} />
            </Box>
          </Box>
        </>)}
      </Box>
    </Box>
    {isExpanded && (
      <Box position='fixed' top='0' left='0' width='100%' height='100vh' bg='rgba(0, 0, 0, .5)' display='flex' justifyContent='center' alignItems='center' zIndex='100000' className="expanded-image-overlay" onClick={toggleImageExpansion}>
        <Box position='relative'>
          <Image
            src={productPhotoUrl}
            alt="Boozen"
            borderRadius='15px'
            border='none'
            width='auto'
            height='auto'
            maxHeight='97vh'
            loading="lazy"
            boxShadow='rgba(0, 0, 0, 0.25) 0px 5px 15px;'
          />
          <Text
            position='absolute'
            top='10px'
            right='10px'
            color='primaryOrange'
            onClick={(e) => {
              e.stopPropagation();
              toggleImageExpansion();
            }}
          >
            <FaTimes />
          </Text>
        </Box>
      </Box>
    )}
    <Modal isOpen={isOpen} onClose={onClose} size="3xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Pesquisa {name}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Image
            src={productFlyerUrl}
            alt='flyer'
          />
        </ModalBody>
      </ModalContent>
    </Modal>

  </>)
}
